export const ContractorTypeEnums = {
    subContractor: 1,
    generalContractor: 2,
    vendor: 3
};
